/*
 * Cart drawer UX helpers.
 *
 * Everything is delegated to `document` and all state lives in the DOM, so the
 * bindings survive theme-editor section swaps and `theme dev` hot reloads (the
 * drawer's inner HTML is re-stamped from its <template> by theme.js).
 *
 * Jobs: toggle `is-scrolled` on the drawer while its body is scrolled (head
 * hairline), and keep the header [data-cart-count] badges - styled exactly
 * like the wishlist counter - in sync after AJAX cart updates.
 */
(function () {
  var DRAWER = '[data-cart-drawer]';
  var BODY = '[data-cart-drawer-body]';

  function sync(body) {
    var drawer = body.closest(DRAWER);
    if (drawer) {
      drawer.classList.toggle('is-scrolled', body.scrollTop > 2);
    }
  }

  // Scroll doesn't bubble; a capture-phase listener on document still sees
  // scroll events from any element, including ones stamped in later.
  document.addEventListener(
    'scroll',
    function (event) {
      var target = event.target;
      if (target && target.nodeType === 1 && target.matches(BODY)) {
        sync(target);
      }
    },
    true
  );

  // Re-sync on open: the body's scroll position is reset by theme.js without
  // firing a scroll event when the drawer re-opens.
  document.addEventListener('theme:cart:open', function () {
    requestAnimationFrame(function () {
      var body = document.querySelector(BODY);
      if (body) sync(body);
    });
  });

  // Header cart counter. theme.js writes the item count into the drawer's
  // [data-cart-items-qty] on every cart build and fires theme:cart:added /
  // theme:cart:loaded - mirror that number into the header badges.
  function syncCartCount() {
    var qtyEl = document.querySelector(DRAWER + ' [data-cart-items-qty]');
    if (!qtyEl) return;
    var count = parseInt(qtyEl.textContent, 10);
    if (isNaN(count)) return;

    document.querySelectorAll('[data-cart-count]').forEach(function (badge) {
      var previous = parseInt(badge.textContent, 10) || 0;
      badge.textContent = count;
      badge.classList.toggle('is-visible', count > 0);
      if (count > previous) {
        badge.classList.remove('is-bumped');
        void badge.offsetWidth;
        badge.classList.add('is-bumped');
      }
    });
  }

  document.addEventListener('theme:cart:added', syncCartCount);
  document.addEventListener('theme:cart:loaded', syncCartCount);
})();
